
import jsPDF from 'jspdf';
import { PDFConfig } from './types';

export const createPDF = () => {
  return new jsPDF('p', 'mm', 'a4');
};

export const getPDFConfig = (pdf: jsPDF): PDFConfig => {
  return {
    pageWidth: pdf.internal.pageSize.getWidth(),
    pageHeight: pdf.internal.pageSize.getHeight(),
    margin: 20,
    lineHeight: 5,
    sectionSpacing: 12,
    headerHeight: 10,
    contentPadding: 4,
    colors: {
      // Neutral palette only — no colored bands
      primary: [0, 0, 0],          // pure black for emphasis
      secondary: [51, 51, 51],     // dark gray
      dark: [0, 0, 0],
      light: [255, 255, 255],
      accent: [245, 245, 245],
      text: [51, 51, 51],          // body text
      gray: [120, 120, 120]        // muted labels
    }
  };
};
